import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react'; // @ts-expect-error Library not migrated yet

import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { getAvatarUrl } from '../../avatar';
import { getUserContactPageUrl } from '../../users';

const UsersAvatarList = ({
  users,
  max = 3,
  hasMoreHref
}) => {
  const handleOnClick = useCallback((e, url) => {
    e.preventDefault();
    window.open(url, '_blank');
  }, []);
  return /*#__PURE__*/_jsx(UIAvatar, {
    hasMoreHref: hasMoreHref,
    lookup: users.map(({
      displayName,
      avatarHash,
      userId
    }) => {
      const url = userId ? getUserContactPageUrl(userId) : undefined;
      return {
        displayName,
        onClick: e => url && handleOnClick(e, url),
        src: avatarHash && getAvatarUrl(avatarHash),
        type: 'contact',
        href: url
      };
    }),
    maxAvatars: max
  });
};

export default UsersAvatarList;